module.exports = __webpack_public_path__ + "static/slide5-big-data-066bbf07dcf6187de1691474b8bf035c.jpg";